"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var maishu_node_web_server_1 = require("maishu-node-web-server");
exports.getLogger = maishu_node_web_server_1.getLogger;
